import axios from 'axios';
import { setAlert } from './alert';
import {
  GET_GETSTARTED,
  GET_GETSTARTEDS,
  GETSTARTED_ERROR,
  DELETE_GETSTARTED,
  ADD_GETSTARTED,
  UPDATE_GETSTARTED
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all GetStarted items
export const getGetStarteds = () => async dispatch => {
  try {
    const res = await axios.get(`${API_URL}/get-started/all`);

    dispatch({
      type: GET_GETSTARTEDS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: GETSTARTED_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get GetStarted by ID
export const getGetStartedById = id => async dispatch => {
  try {
    const res = await axios.get(`${API_URL}/get-started/${id}`);

    dispatch({
      type: GET_GETSTARTED,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: GETSTARTED_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Create GetStarted
export const createGetStarted = (formData, navigate) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.post(`${API_URL}/get-started`, formData, config);

    dispatch({
      type: ADD_GETSTARTED,
      payload: res.data.info
    });

    dispatch(setAlert('GetStarted Created', 'success'));    
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: GETSTARTED_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    
    return null;
  }
};

// Update GetStarted
export const updateGetStarted = (id, formData) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.put(`${API_URL}/get-started/${id}`, formData, config);

    dispatch({
      type: UPDATE_GETSTARTED,
      payload: res.data.info
    });

    dispatch(setAlert('GetStarted Updated', 'success'));
    return true;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: GETSTARTED_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    return false;
  }
};



// Delete GetStarted
export const deleteGetStarted = id => async dispatch => {
  try {
    await axios.delete(`${API_URL}/get-started/${id}`);

    dispatch({
      type: DELETE_GETSTARTED,
      payload: id
    });

    dispatch(setAlert('GetStarted Removed', 'success'));
  } catch (err) {
    dispatch({
      type: GETSTARTED_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}; 